export default __webpack_public_path__ + "static/ReevesCountyTexas-85d485b1c467301d1938793da4629e0d.pdf";